export default {"src":"/_next/static/image/public/images/social_snapchat_blue.7e862d8181a2440678fc7e9e69e14d75.svg","height":18,"width":20};